<template>
  <div class="page-shell">
    <top-bar title="Sobre o App"/>
    <div>
      <div class="container page-content">
        <div class="text-center mb-4">
          <img src="../assets/icone.png" alt="Logo LeCard" style="width: 72px">
        </div>
        <p>
          O LeCard Entregador é o aplicativo oficial para quem realiza entregas com restaurantes que utilizam o sistema LeCard. Compatível com celulares e tablets, o app foi desenvolvido para tornar a rotina dos entregadores mais prática, organizada e conectada com a operação do restaurante.
        </p>
        <p>
          Com o LeCard Entregador, a pessoa responsável pela entrega recebe as informações dos pedidos de forma clara e rápida, podendo também informar diretamente no app quando uma entrega for concluída.
        </p>
        <p>
          Além disso, o restaurante ganha mais controle e agilidade na gestão das entregas, com recursos como rastreio em tempo real do entregador e fila de entregadores, garantindo mais eficiência, visibilidade e uma melhor experiência tanto para quem entrega quanto para quem recebe.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import BottonBar from "../components/BottonBar";
  import TopBar from "@/components/TopBar";

  export default {
    name: 'SobreApp',
    components: {TopBar, BottonBar}
  }
</script>

<style scoped>
.page-shell {
  min-height: 100vh;
  min-height: 100dvh;
}
</style>
